import listEmbeddableMixin from "@/mixins/embeddable/resource/listEmbeddableMixin";
import ProductEmbeddable from "@/views/modules/product/embeddable/ProductEmbeddable";


export default {
    components:{ProductEmbeddable},
    mixins: [listEmbeddableMixin],
    data() {
        return {
            path: "product", //Override somente de front-end, por tanto irá utilizar o mesmo path que o original da página 56
        }

    },
    async mounted() {

        /*Declarar todos os campos no padrão que podem ser utilizados*/

        const formDefault = {
            default: "", //NÃO ESQUECER DOS CAMPOS PADROES DE BUSCA COMO DEFAULT E STATUS (caso existir)
            status:1,
            groupProductId: 0,
            model: "",
        }

        this.form = Object.assign({}, formDefault,this.form);
    },
    methods:{

    }
}